/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import Modal from 'react-bootstrap/Modal';
import PropTypes from 'prop-types';
import AppButton from '../app-button/AppButton';

function AppModal({
  onModalClose,
  showCloseButton,
  modalTitle,
  showFooter,
  cancelText,
  okText,
  children,
  className,
  ...rest
}) {
  return (
    <Modal
      backdrop="static"
      keyboard={false}
      className={`app-modal ${className}`}
      show
      onHide={() => onModalClose(false)}
      {...rest}
    >
      <Modal.Header closeButton={showCloseButton}>
        <Modal.Title>{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      {showFooter && (
        <Modal.Footer>
          <AppButton
            variant="secondary"
            onClick={() => onModalClose(false)}
            btnText={cancelText}
          />
          <AppButton
            variant="primary"
            onClick={() => onModalClose(true)}
            btnText={okText}
          />
        </Modal.Footer>
      )}
    </Modal>
  );
}

AppModal.defaultProps = {
  showFooter: false,
  okText: 'Apply',
  cancelText: 'Close',
  className: '',
  children: null,
};

AppModal.propTypes = {
  showFooter: PropTypes.bool,
  cancelText: PropTypes.string,
  okText: PropTypes.string,
  className: PropTypes.string,
  modalTitle: PropTypes.string.isRequired,
  showCloseButton: PropTypes.bool.isRequired,
  onModalClose: PropTypes.func.isRequired,
  children: PropTypes.any,
};

export default AppModal;
